import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FadeInImage } from 'src/components/shared/FadeInImage';
import { catalogIconUrl } from 'src/models/catalog/CatalogItem';
import { FortuneExchangedItem } from 'src/models/fortune/FortuneExchangedItem';
import { formatDate } from './helper';
import { ReceiveStatus } from './ReceiveStatus';

interface FortuneExchangeHistoryListItemProps {
  exchangedItem: FortuneExchangedItem;
  index: number;
  onClick: (index: number) => void;
}

export const FortuneExchangeHistoryListItem: React.FC<FortuneExchangeHistoryListItemProps> = ({
  exchangedItem,
  index,
  onClick
}) => {
  const { t } = useTranslation(['fortune', 'translation']);
  const handleClick = () => onClick(index);

  const item = exchangedItem.item;
  const changeDateString = formatDate(t, exchangedItem.change_time);

  return (
    <li
      className={css`
        list-style-type: none;
        position: relative;
        &:nth-child(n + 2) {
          margin-top: 2px;
        }
        &:nth-child(n + 2)::after {
          content: '';
          position: absolute;
          top: -2px;
          right: 24px;
          left: 24px;
          border-top: 2px dashed #dcd8bf;
        }
      `}
    >
      <button
        className={css`
          width: 100%;
          text-align: left;
          text-align: start;
          padding: 16px 24px;
          margin: 0;

          &:active {
            background: #ece5d4;
          }
          .change-date {
            color: #938666;
            font-size: 10px;
            margin: 0 0 8px;
          }
        `}
        onClick={handleClick}
      >
        <p className="change-date">{changeDateString}</p>
        <div
          className={css`
            display: flex;
            align-items: center;
            width: 100%;

            .img {
              flex: 0 0 auto;
              height: 48px;
              width: 48px;
              margin: 0 8px 0 0;
            }
            .label-container {
              width: 100%;
              overflow: hidden;
            }
            .label {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              color: #4d3906;
              font-size: 14px;
            }
          `}
        >
          <div className="img">
            <FadeInImage
              src={catalogIconUrl(item.icon)}
              style={{ width: '48px', height: '48px' }}
            />
          </div>
          <div className="label-container">
            <p className="label">{item.label}</p>
            <ReceiveStatus received={!!exchangedItem.deliver_time} />
          </div>
        </div>
      </button>
    </li>
  );
};
